import React from 'react';
import {ModalHandler, useExecuteModal} from "../../hooks/useExecuteModal";
import {Button} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import FleetExpensesStore from "../../stores/FleetExpensesStore";
import FleetExpenseModal from "../modals/fleetExpenses/FleetExpenseModal/FleetExpenseModal";
import {FleetExpenseAction} from "../../models/FleetExpenses/FleetExpensesModel";

const AddFleetExpense = () => {
  const addHandler: ModalHandler = useExecuteModal();
  const onResult: FleetExpenseAction = () => {
    FleetExpensesStore.load({}, true);
  };

  return (
    <>
      <Button onClick={addHandler.executeModal} type={"primary"} size={"small"} icon={<PlusOutlined />}>
        Add Expense
      </Button>
      <FleetExpenseModal onResult={onResult} edit={false} store={FleetExpensesStore} handler={addHandler} />
    </>
  );
};

export default AddFleetExpense;